import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import GeneralContext from "../GeneralContext/GeneralContext";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";
import { Box, Typography } from "@mui/material";


import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import axios from "../../api/axios";

import { ROL_VAL_MINEDUC, ROL_REP_EES, ROL_VAL_SUBTEL} from "../../Constants/Constants";


export default function EmbeddedOperadorGrid() {
  const { includeRol, userSesion } = useContext(GeneralContext);
  const [operador, setOperador] = useState("");
  const [timeRange, setTimeRange] = useState("now-24h"); 

  const baseUrl = "/service/grafana/d-solo/begxmmpoc0dfkc/estado-operadores-influxdb";

  const params = new URLSearchParams({
    "var-Operador": operador,
    "from": timeRange,
    "to": "now",
  });

  const iframeSrc = `${baseUrl}?orgId=1&${params.toString()}`;

  const getOperator = async () => {
    try {
      const response = await axios.getOperator(userSesion.id);
      setOperador(response.data.operador);
    } catch (error) {
      console.error("Error en getOperator:", error);
    }
  };




  useEffect(() => {
    getOperator();
  }, []);

  return (


    <>
       <Grid container spacing={1} sx={{ padding: "0" }}>

         <Grid size={12} sx={{display: "block", minHeight: "200px"}}>
            
          <iframe
            key={iframeSrc + `&panelId=8`}
            src={iframeSrc + `&panelId=8`}
            width="100%"
            height="200"
            frameBorder="0"
            title={`Grafico 1`}
          ></iframe>
          </Grid>

          <Grid size={12} sx={{display: "block", minHeight: "400px"}}>
                <iframe width="100%" height="100%" src="/service/grafana/d-solo/ae4ez5c3t45xcf/home-operador-admin?orgId=1&from=now-1M&to=now&panelId=1" frameBorder="0"></iframe>      
          </Grid>

      </Grid>
  
    </>
  );
}

